/**
 * Ecom module public API. The active ad account is resolved once at init
 * (sourceMedium → adAccounts) and reused for tagging and clickouts.
 */

import type { SdkContext } from '../types';
import { trackEcomClickout, type EcomClickoutDispatchArgs } from './clickout';
import { runEcomInit, type EcomInitOptions } from './init';

export type { EcomClickoutDispatchArgs } from './clickout';
export type { EcomInitOptions } from './init';

export interface EcomModuleApi {
  init(opts?: EcomInitOptions): () => void;
  trackClickout(args: EcomClickoutDispatchArgs): Promise<boolean>;
}

// ac/acm resolve in normalizeSdkConfig (settings → ecom-derived 5/e1, same
// ecom_active signal that enables this module); explicit overrides apply in
// init. The module must not touch analytics config — a partial override here
// splits BI activity classification between senders.
export function createEcomModuleApi(ctx: SdkContext): EcomModuleApi {
  const adAccount = ctx.getActiveAdAccount();

  return {
    init(options) {
      return runEcomInit(ctx, adAccount, options);
    },
    trackClickout(args) {
      return trackEcomClickout(ctx, args);
    },
  };
}
